

<template>
  <div class="contactWarp" v-if="isMobile != 0">
    <div class="pc pw100" v-if="isMobile == 1">
      <header-view ref="headers"></header-view>
      <div class="page page-6" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
        <div class="page6Warp">
          <div class="title fAb flexSw">
            <div>Contact us</div>
            <PcBak :home-index="5"></PcBak>
          </div>
          <div class="contactList">
            <div class="contactItem" v-for="v in contactList" :key="v.id">
              <div class="contactItemTitle fOH">
                {{v.title}}
              </div>
              <div class="contactItemDesc fOH">
                {{v.desc}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile pw100" v-else>
      <mobileHeader></mobileHeader>
      <div class="page page-6">
        <div class="page6Warp flexB h100">
          <div class="zwHeader w100"></div>
          <div class="content flex1 w100">
            <div class="mobileBak">
              <mobileBak :home-index="5"></mobileBak>
            </div>
            <div class="cTop">
              <div class="title fAb">Contact us</div>
              <div class="contactList">
                <div class="contactItem fOH" v-for="v in contactList" :key="v.id">
                  <div class="contactItemTitle fb">
                    {{ v.title }}
                  </div>
                  <div class="contactItemDesc">
                    {{ v.desc }}
                  </div>
                </div>
              </div>
            </div>
            <div class="filingsWarp fOL">
              CopyRight Biotrack Capital .com All Rights Reserved 沪ICP备20013951号-1
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mobileHeader from "@/components/Common/MobileHeader.vue";
import headerView from "@/components/Common/Header.vue";
import PcBak from "@/components/Common/pcBak.vue";
import mobileBak from "@/components/Common/mobileBak.vue";

export default {
  data(){
    return {
      headerHeight: 104,
      footerHeight: 48,
    }
  },
  components: {mobileBak, PcBak, headerView, mobileHeader},
  computed:{
    isMobile(){
      return this.$store.getters.isMobile;
    },

    contactList(){
      return this.$store.getters.homeData.contactList
    }
  },
  created(){
    this.$store.dispatch('setPageCurrentIndex',6)
  },
}
</script>
<style scoped lang="scss">
.pc{
  .page-6{
    height: 100%;
    background-image: url("../../assets/image/page6_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .page6Warp{
      height: 100%;
      width: 70%;
      box-sizing: border-box;
      padding: 1rem 0 1rem;
      margin: auto;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      overflow: hidden;
      overflow-y: auto;
      .contactList{
        color: #fff;
        .contactItem{

          margin-top: 1rem;
          .contactItemTitle{
            font-size: 1.5rem;
          }
          .contactItemDesc{
            font-size: 1.2rem;
            margin-top: .5rem;
          }
        }
      }
      .title{
        text-align: left;
        padding-bottom: 1rem;
        color: #fff;
        font-size: 2.2rem;
        width: 100%;
      }
    }
  }
}
.mobile{
  .page-6{
    height: 100vh;
    background-image: url("../../assets/image/mobile/m_bg_6.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .page6Warp{
      padding: 1.3rem;
      box-sizing: border-box;
      .content{
        flex: 1;
        overflow: hidden;
        color: #fff;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .mobileBak{
          position: absolute;
          right: 0rem;
          top: 1rem;
          z-index: 10;
        }
        .filingsWarp{
          //font-size: .75rem;
          //text-align: center;

          font-size: .6rem;
          text-align: center;
          width: 100%;
        }
        .cTop{
          padding: 1rem 2rem;
          flex: 1;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          .contactList{
            margin-top: 0.5rem;
            .contactItem{

              margin-top: 1rem;
            }
            .contactItemTitle{
              font-size: 1.2rem;
            }
            .contactItemDesc{
              margin-top: .5rem;
              font-size: .9rem;
            }
          }
        }
        .title{

          font-size: 1.5rem;
          margin-top: -20vh;
        }
        .list{
          flex: 1;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
